export const TRACKING_CODES = {
  advertising_terms_link_clicked: 'advertising-terms-link-clicked',
  apply_with_seek_terms_link_clicked: 'apply-with-seek-terms-link-clicked',
  api_terms_link_clicked: 'api-terms-link-clicked',
  connected_partners_link_clicked: 'connected-partners-link-clicked',
  contact_us_link_clicked: 'contact-us-link-clicked',
  email_apisupport_link_clicked: 'email-apisupport-link-clicked',
  talent_contact_us_link_clicked: 'talent-contact-us-link-clicked',
  talent_help_center_link_clicked: 'talent-help-center-link-clicked',
  dev_portal_guide_link_clicked: 'dev-portal-guide-link-clicked',
  dev_portal_link_clicked: 'dev-portal-link-clicked',
  developer_site_link_clicked: 'developer-site-link-clicked',
  privacy_link_clicked: 'privacy-link-clicked',
  talent_partner_link_clicked: 'talent-partner-link-clicked',
  seek_au_link_clicked: 'seek-au-link-clicked',
  seek_nz_link_clicked: 'seek-nz-link-clicked',
  test_cases_link_clicked: 'test-cases-link-clicked',
  product_terms_link_clicked: 'product-terms-link-clicked',
  release_notes_link_clicked: 'release-notes-link-clicked',
  proactive_sourcing_link_clicked: 'proactive-sourcing-link-clicked',
  storybook_link_clicked: 'storybook-link-clicked',
};
